<template>
  <div>
    <div class="air__utils__heading">
      <h5>Add Staff Substitute</h5>
    </div>

    <div v-if="pagepermission.viewable">
          <!-- SEARCH -->
        <div class="row mb-3 align-items-center">
            <div class="col-md-6">
                <a-input-search
                placeholder="Search Staff"
                size="large"
                @search="searchStaffs"
                @change="searchStaffs"
            />
        </div>

        <!-- spacer -->
        <div class="col-md-3"></div>

    <div class="col-md-3 text-right">
        <a-month-picker
        v-model="selectedMonth"
        format="MMMM YYYY"
        size="large"
        @change="onMonthChange"
        placeholder="Select Month"
        />
    </div>
    </div>

      <div class="card">
        <div class="card-body">
          <staff-substitute-table
            :data="data"
            :loading="loading"
            @updateSubstitute="handleSubstituteUpdate"
            @editStaff="editStaff"
            :rolesetting="pagepermission"
          />
        </div>
      </div>
       <!-- PAGINATION -->
      <div class="text-right mt-3">
        <a-pagination
          showSizeChanger
          :total="meta.total"
          :pageSize.sync="pageSize"
          v-model="current"
          @change="onChange"
          @showSizeChange="onShowSizeChange"
        />
      </div>

      <div class="text-right mt-3">
        <a-button type="primary" :loading="submitting" @click="submitSubstitute">
          Submit Substitute
        </a-button>
      </div>
    </div>

    <div v-else>
      <a-spin />
      <p>You don't have permission to use this feature.</p>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { debounce } from 'lodash'
import StaffSubstituteTable from '@/components/staffSubstitute/Table/index.vue'

export default {
  components: { StaffSubstituteTable },

  data() {
    return {
      loading: false,
      submitting: false,
      selectedMonth: moment(),
      data: [],
      meta: {},
      current: 1,
      pageSize: 10,
      searchText: '',
      pagepermission: {
        viewable: false,
      },
    }
  },

  beforeMount() {
    this.$roleutility.checkpermission('staff', 22).then(res => {
      this.pagepermission = res.pagePermission
    })
  },
  created() {
    this.searchStaffs = debounce(this.searchStaffs, 500)
  },

  mounted() {
    this.getStaffs()
    this.getSubstituteData()
  },

  methods: {
    getStaffs() {
      this.loading = true
      this.$http.get('api/staff/attendance/substitute-count', {
        params: {
          limit: this.pageSize,
          page: this.current,
          search: this.searchText,
          month: this.selectedMonth
            ? this.selectedMonth.format('YYYY-MM')
            : null,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data.map(item => ({
          ...item,
          substitute_count: item.substitute_count || 0,
          original_substitute_count: item.substitute_count || 0,
        }))
        this.meta = data.meta
      })
    },
    // getSubstituteData() {
    //   this.loading = true
    //   this.$http.get('/api/staff/attendance/substitute-count', {
    //     params: {
    //       month: this.selectedMonth
    //         ? this.selectedMonth.format('YYYY-MM')
    //         : null,
    //     },
    //   }).then(({ data }) => {
    //     this.loading = false
    //     this.data = data.data
    //   })
    // },
    editStaff(staff) {
      const payload = {
        month: this.selectedMonth.format('YYYY-MM'),
        data: [
          {
            staff_id: staff.staff_id,
            substitute_count: staff.substitute_count,
          },
        ],
      }

      this.$http.post('/api/staff/attendance/substitute-count', payload)
        .then(() => {
          const index = this.data.findIndex(s => s.staff_id === staff.staff_id)
          if (index !== -1) {
            this.$set(
              this.data[index],
              'original_substitute_count',
              staff.substitute_count,
            )
          }

          this.$notification.success({
            message: 'Edit Successful',
            description: 'Substitute count updated',
          })
        })
    },

    // deleteStaff(staff) {
    //   this.$confirm({
    //     title: 'Delete Substitute Count?',
    //     content: 'This will reset substitute count to 0',
    //     okType: 'danger',
    //     onOk: () => {
    //       const payload = {
    //         month: this.selectedMonth.format('YYYY-MM'),
    //         data: [
    //           {
    //             staff_id: staff.staff_id,
    //             substitute_count: 0,
    //           },
    //         ],
    //       }

    //       this.$http.post('/api/staff/attendance/substitute-count', payload)
    //         .then(() => {
    //           const index = this.data.findIndex(
    //             s => s.staff_id === staff.staff_id,
    //           )
    //           if (index !== -1) {
    //             this.$set(this.data[index], 'substitute_count', 0)
    //           }

    //           this.$notification.success({
    //             message: 'Deleted',
    //             description: 'Substitute count reset to 0',
    //           })
    //         })
    //     },
    //   })
    // },

    searchStaffs(e) {
      this.searchText = e.target.value
      this.current = 1
      this.getStaffs()
    },

    onChange(page) {
      this.current = page
      this.getStaffs()
    },
    onMonthChange() {
      this.current = 1
      this.getStaffs()
    },

    onShowSizeChange(current, size) {
      this.current = current
      this.pageSize = size
      this.getStaffs()
    },

    handleSubstituteUpdate({ id, value }) {
      const index = this.data.findIndex(
        s => s.staff_id === id
      )

      if (index !== -1) {
        this.$set(this.data[index], 'substitute_count', value)
      }
    },

    submitSubstitute() {
      this.submitting = true
      const payload = {
        month: this.selectedMonth
          ? this.selectedMonth.format('YYYY-MM')
          : null,
        data: this.data.map(item => ({
          staff_id: item.staff_id,
          substitute_count: item.substitute_count,
        })),
      }

      this.$http.post('/api/staff/attendance/substitute-count', payload)
        .then(() => {
          this.data.forEach((item, index) => {
            this.$set(
              this.data[index],
              'original_substitute_count',
              item.substitute_count,
            )
          })
          this.$notification.success({
            message: 'Success',
            description: 'Staff substitute updated successfully',
          })
        })
        .catch(() => {
          this.$notification.error({
            message: 'Error',
            description: 'There was an error updating staff substitute',
          })
        })
        .finally(() => {
          this.submitting = false
        })
    },
  },
}
</script>
